import { useRouteMatch } from 'react-router-dom';

import { Box } from '@material-ui/core';
import { styled } from '@mui/material/styles';

import HeaderV2 from '../HeaderV2/HeaderV2';
import { LeftNavbarV2 } from '../LeftNavbarV2/LeftNavbarV2';

export const LayoutV2 = ({ children }) => {
  const match = useRouteMatch('/locations/place/:lng/:lat/:zoom');

  return (
    <Container>
      <HeaderV2 />
      <StyledBox noGap={match?.isExact}>
        <LeftNavbarV2 />
        <PageContent>{children}</PageContent>
      </StyledBox>
    </Container>
  );
};

const StyledBox = styled(Box)(({ noGap, theme }) => ({
  display: 'flex',
  height: '100%',
  overflowY: 'auto',
  gap: noGap ? 0 : theme.spacing(3),
}));

const PageContent = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  height: '100%',
}));

const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));
